
<apple-pay-button buttonstyle="black" 
  (click)="applePayClicked($event)"
  type="buy" 
  locale="en"></apple-pay-button>

